import { ArrowUpRight, BookOpen, Home, Sparkles, Users, Hand } from "lucide-react";

const ICONS = { BookOpen, Home, Sparkles, Users, Hand };

export default function Programs({ programs = [] }) {
  return (
    <section
      id="programs"
      data-testid="programs-section"
      className="relative py-20 md:py-32 bg-sand"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-14">
          <div className="md:col-span-7">
            <p className="overline mb-6">What we do</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-ink leading-tight">
              Five interlocking <em className="italic text-terracotta">programs</em>,
              <br className="hidden md:block" />
              one rising city.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 text-graphite leading-relaxed">
            Each program is led by residents from the neighborhoods we serve, with
            funding from grants, individuals and partner enterprises.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {programs.map((p, idx) => {
            const Icon = ICONS[p.icon] || BookOpen;
            // Tetris-style varying spans for visual asymmetry
            const span =
              idx === 0
                ? "md:col-span-7"
                : idx === 1
                ? "md:col-span-5"
                : idx === 2
                ? "md:col-span-4"
                : idx === 3
                ? "md:col-span-4"
                : "md:col-span-4";
            const tall = idx === 0 || idx === 4;
            return (
              <article
                key={p.id}
                data-testid={`program-card-${p.id}`}
                className={`group relative bg-cream border border-line overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(26,28,26,0.35)] ${span}`}
              >
                <div className={`relative ${tall ? "aspect-[16/10]" : "aspect-[16/11]"} overflow-hidden`}>
                  <img
                    src={p.image_url}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4 w-11 h-11 bg-cream/95 backdrop-blur-sm flex items-center justify-center">
                    <Icon size={20} strokeWidth={1.5} className="text-forest" />
                  </div>
                </div>
                <div className="p-7 md:p-8">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className="overline mb-2">{p.impact_metric}</p>
                      <h3 className="text-2xl md:text-3xl text-ink mb-2">
                        {p.title}
                      </h3>
                    </div>
                    <ArrowUpRight
                      size={20}
                      className="text-graphite group-hover:text-terracotta group-hover:rotate-[12deg] transition-all flex-shrink-0 mt-1"
                    />
                  </div>
                  <p className="text-base text-graphite leading-relaxed">
                    {p.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
